export default "__VITE_ASSET__BdP1W6ow__"